// extracted by mini-css-extract-plugin
module.exports = {"root":"TopbarBlank_root__1jNBg","container":"TopbarBlank_container__3ROqK","logoLinkDesktop":"TopbarBlank_logoLinkDesktop__3o9WB","logo":"TopbarBlank_logo__3Qtyr"};